import React from "react";

import { Transactions } from "../../../../components/Transactions";

class TransactionsScreen extends React.Component {
  render() {
    return <Transactions />;
  }
}

export default TransactionsScreen;
